export default class LocalStorageManager {

	BEST_SCORE_KEY = '2048bs';
	GAME_STATE_KEY = '2048gs';

	constructor() {
		this.storage = window.localStorage;
	}

	// Best score getters/setters
	getBestScore() {
		return this.storage.getItem(this.BEST_SCORE_KEY) || 0;
	};

	setBestScore( score ) {
		this.storage.setItem(this.BEST_SCORE_KEY, score);
	};

	// Game state getters/setters and clearing
	getGameState() {
		let stateJSON = this.storage.getItem(this.GAME_STATE_KEY);
		return stateJSON ? JSON.parse(stateJSON) : null;
	};

	setGameState( gameState ) {
		this.storage.setItem(this.GAME_STATE_KEY, JSON.stringify(gameState));
	};

	clearGameState() {
		this.storage.removeItem(this.GAME_STATE_KEY);
	};

}